import WidgetBase from '../widget.base';
import { each } from 'App/lib/util';
import { mq } from '../../lib/util';

export default class ProductDetails extends WidgetBase {
    static selector = '[data-usc-product-details]';
    cardOffsetTop;
    headerOffsetHeight;
    nextElement;

    constructor(el) {
        super(el);

        let self = this;
        this.$el = $(el);
        this.$card = this.$el.find('[data-js-preview-card]');
        this.$infoSection = this.$el.find('[data-js-info-section]');
        this.$headers = this.$el.find('[data-js-header]');
        this.$container = this.$el.find('[data-js-container]');
        this.$videos = this.$el.find('[data-js-prevent-download]');

        this.headerOffsetHeight = $("[data-js-header]").height();
        this.nextElement = this.$el.next();

        if(mq('md') && this.hasCard() && this.$card.height() < this.$infoSection.outerHeight()){
            setTimeout(function(){
                self.$container.css('min-height', `${this.$card.height()}px`);
                self.cardOffsetTop = this.$card.offset().top;
                self.initializeScrollEvent();
                self.handleScrollEvent();

            }.bind(this), 100);
        }

        each(this.$headers, (header) => {
            $(header).on('click', this.headerClick.bind(this));
        });

        this.preventVideoDownloads();

        setTimeout(() => {
            this.loaded();
        });
    }

    preventVideoDownloads() {
        each(this.$videos, (x) => {
            $(x).bind('contextmenu', () => false);
        });
    }

    hasCard() {
        return this.$card.length > 0;
    }

    initializeScrollEvent(){
        let self = this;
        $(window).scroll(function(event){
            self.handleScrollEvent();
        });

        $(window).resize(function(event){
            self.windowResized(event);
        });
    }

    handleScrollEvent(){
        if (!this.hasCard()) {
            return;
        }

        const scrollTop = $(window).scrollTop();
        const isAnchored = this.$card.hasClass('anchor');

        if(this.$card.height() +10 >= this.$container.height()){
            this.removeSticky();
        }
        else if(this.isOutsideOfWidgetBounds() && !isAnchored){
            this.anchorToBottom();
        }
        else if((scrollTop >= this.cardOffsetTop - this.headerOffsetHeight && !isAnchored)
                || (scrollTop + this.headerOffsetHeight < this.$card.offset().top && isAnchored)){
                    this.makeSticky();
        } else{
            this.removeSticky();
        }
    }

    makeSticky(){
        if (!this.hasCard()) {
            return;
        }
        const widthBeforeSticky = this.$card.width();
        this.$card.addClass('sticky')
                   .removeClass('anchor')
                   .width(widthBeforeSticky)
                   .css('top', this.headerOffsetHeight);
    }

    removeSticky(){
        if (!this.hasCard()) {
            return;
        }
        this.$card.removeClass('sticky');
    }

    anchorToBottom(){
        if (!this.hasCard()) {
            return;
        }
        const widgetHeight=this.$el.height();
        const cardHeight = this.$card.height();
        const top = widgetHeight - cardHeight;

        this.$card.removeClass('sticky')
                  .addClass('anchor')
                  .css('top', top + 'px');
    }

    isOutsideOfWidgetBounds(){
        if (!this.hasCard()) {
            return false;
        }
        const cardOffset = this.$card.offset().top + this.$card.height();
        const widgetOffset = this.$el.offset().top + this.$el.outerHeight();
        return cardOffset >= widgetOffset;
    }

    headerClick(e){
        let self = this;
        const $header = $(e.currentTarget);
        if($header.hasClass('open')){
            $header.removeClass('open').next().slideUp(function(){
                if(mq('md')){
                    self.handleScrollEvent();
                }
            }.bind(this));
        } else{
            $header.addClass('open').next().slideDown(function(){
                if(mq('md')){
                    self.handleScrollEvent();
                }
            }.bind(this));
        }
    }

    windowResized(e){
        e.stopPropagation();
        if (!this.hasCard()) {
            return;
        }
        this.$card.removeClass('sticky anchor');
        this.cardOffsetTop = this.$card.offset().top;
    }
}
